import React, { useState } from 'react'
import ListPosts from '../Utils/ListPosts'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { getDataWithId, getNextPostsAPI, getNextWithID, getPagePostsIDAPI } from '../../RTK/Slice/Extract/ExtractPageWithIdSlice'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const ExtractPagePostId = () => {

    // For Dispatch Action
    const dispatch = useDispatch(); 

    // For Translate Page
    const {t} = useTranslation() ; 

    // For Store ID Search
    const [ID , setId] = useState('') ; 

    // For Access Data  (pagePosts + status)
    const {pagePosts , status} = useSelector(getDataWithId) ; 


    // For Get Token 
    const token = useSelector(getToken) ; 

    // For Get Active Token
    const activeToken = useSelector(getActiveToken) ; 

    // For Dispatch Action
    const disptach = useDispatch() ;

    const getPagePostsWithIdHandler = (id)=>{
        if(ID.length > 5) {
            disptach(getPagePostsIDAPI({token , userToken : activeToken , pageId : ID}))
        }else{
            toast.info("Please Enter Valid ID")
        }
    }

    // For Access The Next
    const hasNext = useSelector(getNextWithID) ; 


    // For Get The Next Handle 
    
    const hasNextHandler = ()=>{
        if(hasNext)
        {
            dispatch(getNextPostsAPI({token , userToken :activeToken , pageId : ID , hasNext }))
        }
    }


  return (
    <div>
        <div style={{display : "flex" }}>
            <div style={{width : "300px" ,marginBottom : "15px" , borderRadius : "22px"}} className='search-barf'>
                <FontAwesomeIcon icon={faMagnifyingGlass} />
                <input value={ID} onChange={(e)=>setId(e.target.value)}  placeholder={`Search Page ID` } />
            </div>
            <button onClick={getPagePostsWithIdHandler} className='search-btn'>{t("search")} </button>
        </div>
        <ListPosts hasNext={hasNext} hasNextHandler={hasNextHandler}  posts={pagePosts} status={status}  />

    </div>
  )
}

export default ExtractPagePostId
